import { Entity } from "src/app/core/data/schema/entity";
import { DateTimeHelper } from "src/app/core/helper/datetime.helper";
import { DateTime } from 'luxon';

/**
 * Event Instance
 */
export class EventInstance extends Entity {

    static className = 'EventInstance';
    static  idField = 'eventInstanceId';
    
    eventInstanceId: number = 0;
    eventId: number;
    specialNotes: string;
    startDate: string;
    endDate: string;
    remainingSpots: number;

    // not from api
    startTimeString: string;
    startTimeDate: Date;
    
    startDateObj: DateTime;
    endDateObj: DateTime;

    endTimeString: string;
    endTimeDate: Date;

    eventFromTo: string;
    
    get isPast() {return this.endTimeDate != null && this.endTimeDate < new Date()};

    constructor(evtInstance?: Partial<EventInstance>) {
        super();
        Object.assign(this, evtInstance);
        this.initDates();
    }

    initDates() {
        if ( this.startDate != null ) {
            this.startDateObj = DateTime.fromISO(this.startDate, { zone: 'utc' });
            this.startDateObj = this.startDateObj.setZone('local');
            this.endDateObj = DateTime.fromISO(this.endDate, { zone: 'utc' });
            this.endDateObj = this.endDateObj.setZone('local');
            
            if (!this.startDate.endsWith('Z')) { this.startDate = this.startDate + 'Z'; }
            this.startTimeDate = new Date(this.startDate);
            this.startTimeString = DateTimeHelper.formatDate(this.startDate);
            //this.isPast = this.endTimeDate < new Date();
    
            if (!this.endDate.endsWith('Z')) { this.endDate = this.endDate + 'Z'; }
            this.endTimeDate = new Date(this.endDate);
            this.endTimeString = DateTimeHelper.formatDate(this.endDate, true);

            this.eventFromTo = DateTimeHelper.readableDateRange(this.startDateObj, this.endDateObj);
        }
    }


    // ----------------------------------------------------
    // Service-like features from here on down
    // ----------------------------------------------------
    public static async fetchForEvent(eventId: number) {
        return await EventInstance.fetchChildrenFor(EventInstance, eventId, null, `forEvent/${eventId}`); 
    }
}
